export enum ContainType {
  Contains,
  DoesNotContain,
}
